import { basicLogger, withLDProvider } from 'launchdarkly-react-client-sdk';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { App } from '@/app';
import { config } from '@/config';
import { applicationDataSelector } from '@/store/slices/application-data';

const LDProvider = () => {
  const { ouData } = useSelector(applicationDataSelector);

  const LDInnerProvider = useMemo(() => {
    const context = ouData?.ouId
      ? {
        kind: 'user',
        key: ouData.ouId,
        OUId: ouData.ouId,
      }
      : undefined;

    return withLDProvider({
      clientSideID: config.featureFlagServiceClientKey,
      context,
      reactOptions: {
        useCamelCaseFlagKeys: false,
      },
      options: {
        /* ... */
        sendEventsOnlyForVariation: true,
        logger: basicLogger({
          level: 'warn',
        }),
      },
    })(App);
  }, [ouData?.ouId]);

  return <LDInnerProvider />;
};

export default LDProvider;
